import { GRAPHQL_DATE_FORMAT } from "../helpers/sharedConstants"
import { push } from "react-router-redux"
import qs from "querystring"
import moment from "moment"
import { replace } from "react-router-redux"

const initialState = {
  startDate: moment()
    .subtract(30, "days")
    .startOf("day")
    .toJSON(),
  endDate: moment()
    .subtract(1, "days")
    .startOf("day")
    .toJSON(),
}

const dateRangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE": {
      let params, startDate, endDate
      if (
        (params = qs.parse(action.payload.search.substring(1))) &&
        params.startDate &&
        params.endDate &&
        (startDate = moment(params.startDate, GRAPHQL_DATE_FORMAT)).isValid() &&
        (endDate = moment(params.endDate, GRAPHQL_DATE_FORMAT)).isValid()
      ) {
        return {
          ...state,
          startDate: startDate.toJSON(),
          endDate: endDate.toJSON(),
        }
      } else {
        return state
      }
    }
    default:
      return state
  }
}

// Action generator to change the dateRange state.
const updateDateRange = (startDate, endDate) =>
  push({
    search: qs.stringify({
      startDate: startDate.format(GRAPHQL_DATE_FORMAT),
      endDate: endDate.format(GRAPHQL_DATE_FORMAT),
    }),
  })

// This middleware ensures that the date range is always in the url if you're on a utilization page.
const dateRangeMiddleware = store => next => action => {
  if (
    // We're at a utilization page and there is no date range in the url.
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.pathname.includes("utilization") &&
    action.payload.search === "" &&
    store.getState().dateRange.startDate &&
    store.getState().router.location
  ) {
    action.payload.search =
      "?" +
      qs.stringify({
        startDate: moment(store.getState().dateRange.startDate).format(
          GRAPHQL_DATE_FORMAT
        ),
        endDate: moment(store.getState().dateRange.endDate).format(
          GRAPHQL_DATE_FORMAT
        ),
      })
    store.dispatch(replace(action.payload))
  } else if (
    // We're NOT at a utilization page and there IS a date range in the url.
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.search.includes("startDate") ||
      action.payload.search.includes("endDate")) &&
    !action.payload.pathname.includes("utilization")
  ) {
    const params = qs.parse(action.payload.search.substring(1))
    delete params["startDate"]
    delete params["endDate"]
    action.payload.search = "?" + qs.stringify(params)
    store.dispatch(replace(action.payload))
  } else {
    next(action)
  }
}

export { dateRangeReducer, updateDateRange, dateRangeMiddleware }
